import React from 'react';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';

import PlanerLogo from 'assets/images/relifCompanies/planer-logo.webp';
import SikerLogo from 'assets/images/relifCompanies/siker-logo.webp';
import ZellerLogo from 'assets/images/relifCompanies/zeller-logo.webp';

const NavigationTopBar = () => {
  const isProd = window.location.hostname !== 'localhost';
  const planerUrl = isProd ? 'https://planer.ai' : 'http://localhost:3002';
  const zellerUrl = isProd ? 'https://zeller.ai' : 'http://localhost:3000';

  return (
    <Container maxWidth="xl">
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          component="a"
          href={planerUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            '& img': {
              width: '80px',
              height: 'auto',
              opacity: 0.6,
              transition: 'opacity 0.3s ease',
            },
            '&:hover img': {
              opacity: 1,
            },
          }}
        >
          <img src={PlanerLogo} alt="Planer" />
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box
          component="a"
          href={zellerUrl}
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            '& img': {
              width: '80px',
              height: 'auto',
              opacity: 0.6,
              transition: 'opacity 0.3s ease',
            },
            '&:hover img': {
              opacity: 1,
            },
          }}
        >
          <img src={ZellerLogo} alt="Zeller" />
        </Box>
        <Divider orientation="vertical" flexItem />
        <Box
          component="a"
          href="https://siker.ai"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            '& img': {
              width: '62px',
              height: 'auto',
              opacity: 0.6,
              transition: 'opacity 0.3s ease',
            },
            '&:hover img': {
              opacity: 1,
            },
          }}
        >
          <img src={SikerLogo} alt="Siker" />
        </Box>
      </Box>
    </Container>
  );
};

export default NavigationTopBar;
